import { render } from "./ServiceBlock.vue?vue&type=template&id=2f3b2036&scoped=true"
import script from "./ServiceBlock.vue?vue&type=script&lang=js"
export * from "./ServiceBlock.vue?vue&type=script&lang=js"

import "./ServiceBlock.vue?vue&type=style&index=0&id=2f3b2036&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3b2036"]])

export default __exports__